/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import { Select, Modal, Spin, Empty, Icon } from 'antd';
import postService from '../../../services/httpService';
import networkList from '../../../constants/networkList';
import {validRoomTypes, insuranceCompanyCodes, units} from '../../../constants/app-constants';
import Storage from '../../../services/local-store';
import { optionsStore } from '../../../selectStore';
import rootReduxStore from '../../../reduxStore/rootStore';
import { data } from 'jquery';
const { Option } = Select;
let came = 0;
class Selectlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: [],
            value: null,
            feild: {},
            selet_options: [],
            length_Of_Stay: '',
        };
        this.inputChange = this.inputChange.bind(this);
        this.inputBlur = this.inputBlur.bind(this);
        this.fetchSearchData = this.fetchSearchData.bind(this);
    }
    componentDidMount() {
        let { feild_data } = this.props;
        this.setState({ 'feild': feild_data, 'value': feild_data.value }, () => {
            this.renderOptions(feild_data);
        })

    }

    componentDidUpdate(prevProps, prevState) {
        let prev_value = prevState.value
        let { feild_data } = this.props;
        if (feild_data.value !== prev_value && came === 0) {

            this.setState({ 'feild': feild_data, 'value': feild_data.value }, () => {
                this.renderOptions(feild_data);
                if (feild_data.value) {
                    this.selectFetchCall();
                }
            })
        }
    }

    componentWillUnmount() {
        came = 0;
        this.setState({
            date: new Date(),
            error: [],
            value: null,
            feild: {},
            selet_options: [],
        })
    }


    renderOptions(feild_data) {
        // let { base_url } = this.props.networkList
        const {
            getCounsellingType,
            getMasterCareManagement,
            getMasterEstimateTypes,
            getProcedures,
            getDoctorsforDropdown,
            getPaymentTypes,
            getCashNonPackageRoomsByUnitId,
            getroomNamesonImages,
            getServicesByHeaderId,
            getAllTpas,
            getAllInsuranceCompanies
        } = networkList;
        const Option = Select.Option;
        let children = [];




        // if (feild_data.name === 'roomtypes') {
        //     try {
        //         postService(getroomNamesonImages, 'GET', {}).then(res => {
        //             if (res['status']) {
        //                 res['data'].map((data, key) => {
        //                     children.push(<Option key={key} value={`${data.id}`}>{`${data.name}`}</Option>)
        //                 })
        //                 this.setState((state) => ({ 'selet_options': children }));
        //             } else {
        //                 this.setState((state) => ({ 'selet_options': [] }));
        //                 Modal.error({
        //                     title: 'Error message',
        //                     content: `${res.message}`,
        //                 });
        //             }
        //         })

        //         this.setState((state) => ({ 'selet_options': children }));
        //     } catch (error) {
        //         this.setState((state) => ({ 'selet_options': [] }));
        //         console.log(error);
        //     }
        // }
        if (feild_data.name === 'doctor_name') {
            try {
                postService(getDoctorsforDropdown, 'GET', {}).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} value={`${data.id}`}>{`${data.name}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children }));
                    } else {
                        this.setState((state) => ({ 'selet_options': [] }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })

                this.setState((state) => ({ 'selet_options': children }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [] }));
                console.log(error);
            }
        }

        if (feild_data.name === 'payment_mode') {
            try {
                postService(getPaymentTypes, 'GET', {}).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} value={`${data.id}`}>{`${data.name}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children }));
                    } else {
                        this.setState((state) => ({ 'selet_options': [] }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })

                this.setState((state) => ({ 'selet_options': children }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [] }));
                console.log(error);
            }
        }

        if (feild_data.name === 'counselling_type') {
            try {
                postService(getCounsellingType, 'GET', {}).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children }));
                    } else {
                        this.setState((state) => ({ 'selet_options': [] }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })

                this.setState((state) => ({ 'selet_options': children }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [] }));
                console.log(error);
            }
        }

        if (feild_data.name === 'signature_of_patient_attendant') {
            try {
                children.push(<Option value="1">Patient</Option>,
                    <Option value="2">Attendant</Option>)

                this.setState((state) => ({ 'selet_options': children }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [] }));
                console.log(error);
            }
        }

        if (this.props.form_openn === 'cash') {
            // if (feild_data.name === 'counselling_type') {
            //     try {
            //         // postService(getCounsellingStationsDropDown, 'POST', {}).then(res => {
            //         //     if (res['status']) {
            //         //         res['data'].map((data, key) => {
            //         //             children.push(<Option key={key} value={`${data._id}`}>{`${data.designation}`}</Option>)
            //         //         })
            //         //         this.setState((state) => ({ 'selet_options': children }));
            //         //     } else {
            //         //         this.setState((state) => ({ 'selet_options': [] }));
            //         //         Modal.error({
            //         //             title: 'Error message',
            //         //             content: `${res.message}`,
            //         //         });
            //         //     }
            //         // })
            //         // children.push(<Option value="Initial">Initial</Option>,
            //         //     <Option value="Recounselling">Recounselling</Option>)

            //         this.setState((state) => ({ 'selet_options': children }));
            //     } catch (error) {
            //         this.setState((state) => ({ 'selet_options': [] }));
            //         console.log(error);
            //     }
            // }

            // if (feild_data.name === 'surgery_procedure_name' || feild_data.name === 'additional_procedure') {
            //     try {
            //         postService(getProcedures, 'GET', {}).then(res => {
            //             if (res['status']) {
            //                 res['data'].map((data, key) => {
            //                     children.push(<Option key={key} value={`${data.id}`}>{`${data.name}`}</Option>)
            //                 })
            //                 this.setState((state) => ({ 'selet_options': children }),()=>{
            //                     // this.inputBlur();
            //                 });
            //             } else {
            //                 this.setState((state) => ({ 'selet_options': [] }));
            //                 Modal.error({
            //                     title: 'Error message',
            //                     content: `${res.message}`,
            //                 });
            //             }
            //         })

            //         this.setState((state) => ({ 'selet_options': children }));
            //     } catch (error) {
            //         this.setState((state) => ({ 'selet_options': [] }));
            //         console.log(error);
            //     }
            // }

            // if (feild_data.name === 'additional_procedure') {
            //     try {
            //         children.push(<Option value="1">ABANDONED PBMV (PERCUTANEOUS BALLOON MITRAL VALVULOPLASTY)</Option>,
            //             <Option value="2">ABANDONED PTCA (PERCUTANEOUS TRANSLUMINAL CORONARY ANGIOPLASTY)</Option>,
            //             <Option value="3">AICD IMPLANTATION DUAL CHAMBER</Option>,
            //             <Option value="4">AICD IMPLANTATION SINGLE CHAMBER</Option>,
            //             <Option value="5">AORTIC ANGIOPLASTY</Option>,
            //             <Option value="6">AORTIC ANGIOPLASTY CO2 (CARBON DIOXIDE)</Option>,
            //             <Option value="7">AORTOGRAM</Option>,
            //             <Option value="8">ASD (ATRIAL SEPTAL DEFECT) DEVICE CLOSURE</Option>,
            //             <Option value="9">ATHERECTOMY</Option>,
            //             <Option value="10">AVBD (AORTIC VALVE BALLOON DILATATION)</Option>)

            //         this.setState((state) => ({ 'selet_options': children }));
            //     } catch (error) {
            //         this.setState((state) => ({ 'selet_options': [] }));
            //         console.log(error);
            //     }
            // }

            // if (feild_data.name === 'doctor_name') {
            //     try {
            //         children.push(<Option value="One">One</Option>,
            //             <Option value="Two">Two</Option>,
            //             <Option value="Three">Three</Option>,
            //             <Option value="Four">Four</Option>)

            //         this.setState((state) => ({ 'selet_options': children }));
            //     } catch (error) {
            //         this.setState((state) => ({ 'selet_options': [] }));
            //         console.log(error);
            //     }
            // }

            // if (feild_data.name === 'package_name') {
            //     try {
            //         children.push(<Option value="1">CABG</Option>,
            //             <Option value="2">ASD</Option>,
            //             <Option value="3">CSD-SURGICAL CLOSURE</Option>,
            //             <Option value="4">AVR</Option>,
            //             <Option value="5">MVR</Option>,
            //             <Option value="6">DVR</Option>,
            //             <Option value="7">CORONARY ANGIOGRAM</Option>,
            //             <Option value="8">PTRA</Option>,
            //             <Option value="9">PDA</Option>,
            //             <Option value="10">ASD-DEVICE PROCEDURE</Option>)

            //         this.setState((state) => ({ 'selet_options': children }));
            //     } catch (error) {
            //         this.setState((state) => ({ 'selet_options': [] }));
            //         console.log(error);
            //     }
            // }

            if (feild_data.name === 'additional_package') {
                try {
                    children.push(<Option value="1">CABG</Option>,
                        <Option value="2">ASD</Option>,
                        <Option value="3">CSD-SURGICAL CLOSURE</Option>,
                        <Option value="4">AVR</Option>,
                        <Option value="5">MVR</Option>,
                        <Option value="6">DVR</Option>,
                        <Option value="7">CORONARY ANGIOGRAM</Option>,
                        <Option value="8">PTRA</Option>,
                        <Option value="9">PDA</Option>,
                        <Option value="10">ASD-DEVICE PROCEDURE</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }
        }

        if (this.props.form_openn === 'insurance') {
            if (feild_data.name === 'ins_ailment_capping') {
                try {
                    children.push(<Option value="1">Yes</Option>,
                        <Option value="2">No</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }
            if (feild_data.name === 'ins_select_difference') {
                try {
                    children.push(
                    // <Option value="1">Room Difference</Option>,
                        <Option value="2">Pro Rate Difference</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }
        }

        if (this.props.form_openn === 'corporate') {

            if (feild_data.name === 'organization') {
                try {
                    children.push(<Option value="BHEL">BHEL</Option>,
                        <Option value="Indian Railways">Indian Railways</Option>,
                        <Option value="CISF">CISF</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'payment_cashless') {
                try {
                    children.push(<Option value="Payment">Payment</Option>,
                        <Option value="Cashless">Cashless</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'self_dependant') {
                try {
                    children.push(<Option value="Self">Self</Option>,
                        <Option value="Dependant">Dependant</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'emp_working_status') {
                try {
                    children.push(<Option value="Working">Working</Option>,
                        <Option value="not Working">not Working</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'member_relationship') {
                try {
                    children.push(<Option value="Wife">Wife</Option>,
                        <Option value="Husband">Husband</Option>,
                        <Option value="Children">Children</Option>,
                        <Option value="Father">Father</Option>,
                        <Option value="Mother">Mother</Option>,
                        <Option value="Cousin">Cousin</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'disability') {
                try {
                    children.push(<Option value="yes">yes</Option>,
                        <Option value="no">no</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'emp_grade') {
                try {
                    children.push(<Option value="Grade A">Grade A</Option>,
                        <Option value="Grade B">Grade B</Option>,
                        <Option value="Grade C">Grade C</Option>,
                        <Option value="Grade D">Grade D</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'care_management') {
                try {
                    children.push(<Option value="Surgical">Surgical</Option>,
                        <Option value="Medical">Medical</Option>)

                    this.setState((state) => ({ 'selet_options': children }),()=>{

                    });
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'estimate_type') {
                try {
                    children.push(<Option value="package">Package</Option>,
                        <Option value="nonpackage">Non Package</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'dialysis_radiation') {
                try {
                    children.push(<Option value="Dialysis">Dialysis</Option>,
                        <Option value="Radiation">Radiation</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'surgery_procedure_name') {
                try {
                    children.push(<Option value="1">ABANDONED PBMV (PERCUTANEOUS BALLOON MITRAL VALVULOPLASTY)</Option>,
                        <Option value="2">ABANDONED PTCA (PERCUTANEOUS TRANSLUMINAL CORONARY ANGIOPLASTY)</Option>,
                        <Option value="3">AICD IMPLANTATION DUAL CHAMBER</Option>,
                        <Option value="4">AICD IMPLANTATION SINGLE CHAMBER</Option>,
                        <Option value="5">AORTIC ANGIOPLASTY</Option>,
                        <Option value="6">AORTIC ANGIOPLASTY CO2 (CARBON DIOXIDE)</Option>,
                        <Option value="7">AORTOGRAM</Option>,
                        <Option value="8">ASD (ATRIAL SEPTAL DEFECT) DEVICE CLOSURE</Option>,
                        <Option value="9">ATHERECTOMY</Option>,
                        <Option value="10">AVBD (AORTIC VALVE BALLOON DILATATION)</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'additional_procedure') {
                try {
                    children.push(<Option value="Procedure One">Procedure One</Option>,
                        <Option value="Procedure Two">Procedure Two</Option>,
                        <Option value="Procedure Three">Procedure Three</Option>,
                        <Option value="Procedure Four">Procedure Four</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'package_name') {
                try {
                    children.push(<Option value="1">CABG</Option>,
                        <Option value="2">ASD</Option>,
                        <Option value="3">CSD-SURGICAL CLOSURE</Option>,
                        <Option value="4">AVR</Option>,
                        <Option value="5">MVR</Option>,
                        <Option value="6">DVR</Option>,
                        <Option value="7">CORONARY ANGIOGRAM</Option>,
                        <Option value="8">PTRA</Option>,
                        <Option value="9">PDA</Option>,
                        <Option value="10">ASD-DEVICE PROCEDURE</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'additional_package') {
                try {
                    children.push(<Option value="Pack One">Pack One</Option>,
                        <Option value="Pack Two">Pack Two</Option>,
                        <Option value="Pack Three">Pack Three</Option>,
                        <Option value="pack Foir">pack Foir</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'room_eligibility') {
                try {
                    children.push(<Option value="General">General</Option>,
                        <Option value="Twin Sharing">Twin Sharing</Option>,
                        <Option value="Single">Single</Option>,
                        <Option value="Deluxe">Deluxe</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'room_upgrade') {
                try {
                    children.push(<Option value="General">General</Option>,
                        <Option value="Twin Sharing">Twin Sharing</Option>,
                        <Option value="Single">Single</Option>,
                        <Option value="Deluxe">Deluxe</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'emp_designation') {
                try {
                    children.push(<Option value="Executive">Executive</Option>,
                        <Option value="Sr. Executive">Sr. Executive</Option>,
                        <Option value="Manager">Manager</Option>,
                        <Option value="Sr. manager">Sr. manager</Option>,
                        <Option value="GM">GM</Option>,
                        <Option value="AVP">AVP</Option>,
                        <Option value="VP">VP</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

            if (feild_data.name === 'clearence_option') {
                try {
                    children.push(<Option value="yes">Yes</Option>,
                        <Option value="no">No</Option>)

                    this.setState((state) => ({ 'selet_options': children }));
                } catch (error) {
                    this.setState((state) => ({ 'selet_options': [] }));
                    console.log(error);
                }
            }

        }
    }



    inputChange(value) {
        // console.log(value)
        let { feild_data } = this.props;
        if (value !== undefined) {
            this.setState({ 'value': value }, () => {
                this.inputBlur();
            });
        }
        else {
            this.setState({ 'value': '' }, () => {
                this.inputBlur();
            });
        }
    }

    inputBlur() {
        let { value, error } = this.state;
        let { feild_data } = this.props;
        let data = this.state.selet_options


        if (feild_data.name === 'room_opted' || feild_data.name === 'room_upgrade' || feild_data.name === 'icu_opted') {
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['amount'] = feild.props.amount;
                    feild_data['room_id'] = feild.props.room_id;
                    feild_data['text'] = feild.props.children;
                    feild_data['ward_groupname'] = feild.props.ward_groupname;
                    feild_data['wardgroupname'] = feild.props.wardgroupname;
                    feild_data['room_charges'] = feild.props.room_charges;
                    feild_data['room_charges_non']= feild.props.room_charges_non;
                }
            })
        }
        else if (feild_data.name === 'room_upgrade_reason') {
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                }
            })
        }
        else if (feild_data.name === "package_name") {
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['length_of_stay'] = feild.props.length_of_stay;
                    feild_data['pack_name'] = feild.props.children;
                }
            })
        }
        else if (feild_data.name === "doctor_name") {
            data.map((feild, key) => {
                if (feild.id === value) {
                    this.props.selet_options({
                        id: data.id,
                        speciality: data.speciality
                    })
                }
            })
            this.props.buttonClick()
        } else if (feild_data.name === "insurance_company_name") {

            console.log('insurance_company_name',value);

            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value == value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['tariff_mapped'] = feild.props.tariff_mapped;
                    feild_data['hims_org_code'] = feild.props.hims_org_code;
                    feild_data['insurance_company_mou_flag'] = feild.props.insurance_company_mou_flag;
                }
            })
        } else if (feild_data.name === "ins_package_name") {
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.text;
                    feild_data['length_of_stay'] = feild.props.length_of_stay;
                }
            })
        }
        if (feild_data.name === 'surgery_procedure_name' ) {
            let { selet_options,length_Of_Stay } = this.state;
            console.log("lengthOfStay 694",length_Of_Stay);
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['selected_option'] = feild.props.option_data;
                    feild_data['lengthofstay'] = length_Of_Stay;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                }
            })
        }
        if (feild_data.name === 'ins_surgery_procedure_name') {
            let { selet_options, length_Of_Stay } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['selected_option'] = feild.props.option_data;
                    feild_data['lengthofstay'] = length_Of_Stay;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                }
                console.log("lengthOfStay 706",length_Of_Stay);
            })
        }
        if (feild_data.name === 'ins_room_upgrade_reason') {
            let { selet_options } = this.state;
            console.log("this.state",this.state);
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                }
            })
        }
        if (feild_data.name === 'length_of_stay') {
            let { selet_options } = this.state;
            console.log("this.state",this.state);
        }
        if (feild_data.name === 'ins_room_eligible_ward_names' || feild_data.name === 'ins_upgrade_room_names' || feild_data.name === 'ins_icu_type') {
            let type_of_package = null
            type_of_package = localStorage.getItem('type_of_package');
            let { selet_options } = this.state;
            console.log('selet_options:', selet_options)
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    // feild_data['id'] = feild.id;
                    // feild_data['name'] = feild.name;
                    feild_data['parrentMode'] = feild.props.parrentMode;
                    feild_data['parrentName'] = feild.props.parrentName;
                    feild_data['amount'] = feild.props.amount;
                    feild_data['room_charges'] = feild.props.room_charges;
                    feild_data['package_id'] = feild.props.package_id;
                    feild_data['package_charges'] = feild.props.package_charges;
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                    feild_data['option_data'] = feild.props.select_data
                    // ins_room_eligible_ward_names
                    // feild_data['']
                    feild_data['ward_groupname'] = feild.props.ward_groupname;
                    feild_data['wardgroupname'] = feild.props.wardgroupname;
                }
            })
        }
        if ( feild_data.name === 'ins_additional_package_name') {
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                }
            })
        }
        if (feild_data.name === 'category') {
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['value'] = value;
                    feild_data['error'] = error;
                    feild_data['text'] = feild.props.children;
                }
            })
        }
        if (feild_data.name === 'ins_select_difference') {
            // let { selet_options } = this.state;
            // selet_options.map((feild, key) => {
                // if (feild.props.value === value) {
                    feild_data['value'] = '2';
                    feild_data['error'] = error;
                    feild_data['text'] = 'Pro Rate Difference';
                // }
            // })
        }
        else {            
            let { selet_options } = this.state;
            selet_options.map((feild, key) => {
                if (feild.props.value === value) {
                    feild_data['text'] = feild.props.children;
                }
            })
            feild_data['value'] = value;
            feild_data['error'] = error;
        }
        this.props.inputChange(feild_data)
    }

    onFocus() {
        console.log('focus');
        this.setState({ select2options: [], loading: true });
        this.selectFetchCall();
    }

    selectFetchCall(val) {
        let { feild_data, medicationDetailsSchema, InsuranceDetailsSchema, basic_info } = this.props;
        this.setState({ fetching: true });
        let children = [];

        const {
            getCashPackagePricesById,
            getCashNonPackageRoomsByUnitId,
            getRoomUpgradeReasons,
            getMasterCareManagement,
            getMasterEstimateTypes,
            getPackagesForDropDown,
            getServicesByHeaderId,
            getAllTpas,
            getAllInsuranceCompanies,
            getMasterInsuranceStatus,
            getMasterPatientTypes,
            getMasterInsuranceTypes,
            getProcedures,
            getPackagePricesById,
            getMastericuTypes,
            getInsuranceNonPackageRoomsByUnitId,
            getInsurancePackagePricesById,
            getCallLogCategories
        } = networkList;



        if (feild_data.name === 'excludes_service_id') {


            optionsStore.subscribe(() => {
                let option_data = optionsStore.getState()

                option_data.map((data, key) => {
                    children.push(<Option key={key} disabled={false} value={`${data.id}`} service={`${data.service}`} amount={`${data.price}`}>{`${data.service}`}</Option>)
                })
                this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                    // this.inputBlur();
                });
            })
        }

        if (feild_data.name === 'room_opted' || feild_data.name === 'room_upgrade') {
            let user_data, user_unit_id, room_opted_amount, estimate_type, package_id;
            medicationDetailsSchema.map((feild, key) => {
                if (feild['name'] === 'estimate_type') {
                    estimate_type = parseInt(feild['value']);
                }
                if (feild['name'] === 'package_name') {
                    package_id = parseInt(feild['value']);
                }
                if (feild['name'] === 'room_opted') {
                    room_opted_amount = parseFloat(feild['room_charges']) ? parseFloat(feild['room_charges']) : parseFloat(feild['room_charges_non']);
                }
            })

            user_data = JSON.parse(Storage.get('user_data'));
            user_unit_id = user_data.unitid;
            let tariff_id;
            if (parseInt(basic_info['payment_type']) === 1) {
                tariff_id = 1;
            }
            console.log('PROPS:::', this.props, this.state);
            if (estimate_type === 1) { // 1 - package, 2 - non-package
                if (basic_info['payment_type'] === 1) { // 1 - Cash, 2 - Insurance
                    // postService(getCashPackagePricesById, 'POST', { "data": { "package_id": 4017, "unit_id": user_unit_id } }).then(res => {
                        postService(getInsurancePackagePricesById, 'POST', { "data": { "package_id": this.props.procedureValue || this.props.feilds[4].value, "unit_id": user_unit_id, "tariff_id": "TR1", "form_type": 1} }).then(res => {    
                        if (res['status']) {
                            if (res['data'].length !== 0) {
                                let dataroom=res['data'];
                                 dataroom.sort(function (a, b) {
                                    return a.amount - b.amount;
                                  });
                                  dataroom.map((data, key) => {
                                    let disable = (feild_data.name === 'room_upgrade') ? (room_opted_amount !== null && parseFloat(room_opted_amount) >= parseFloat(data.room_charges)) ? true : false : false;

                                    children.push(<Option key={key} disabled={disable} value={`${data.room_name}`} room_id={`${data.room_id}`} amount={`${data.package_charges}`} room_charges={`${data.room_charges}`} ward_groupname = {`${data.ward_groupname}`}>{`${data.room_name}`}</Option>)
                                })
                                this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                                    // this.inputBlur();
                                });
                            }
                        } else {
                            this.setState((state) => ({ 'selet_options': [], fetching: false }));
                            Modal.error({
                                title: 'Error message',
                                content: `${res.message}`,
                            });
                        }
                    });
                }
            }
            else {
                postService(getInsuranceNonPackageRoomsByUnitId, 'POST', { "data": { "unit_id": user_unit_id, "payment_type": 1, "tariff_id": "TR1", "room_type": 0, } }).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            // let disable = (feild_data.name === 'room_upgrade') ? (room_opted_amount !== null && parseFloat(room_opted_amount) >= parseFloat(data.amount)) ? true : false : false;
                            let disable = (feild_data.name === 'room_upgrade') ? (room_opted_amount !== null && parseFloat(room_opted_amount) >= parseFloat(data.amount)) ? true : false : false;

                            children.push(<Option key={key} disabled={disable} value={`${data.id}`} room_id={`${data.room_id}`} amount={`${data.amount}`} wardgroupname={`${data.wardgroupname}`} room_charges_non={`${data.amount}`}>{`${data.room_name}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                            // this.inputBlur()
                        });
                    } else {
                        this.setState((state) => ({ 'selet_options': [], fetching: false }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                });
            }
        }

        if (feild_data.name === 'icu_opted') {
            let user_data, user_unit_id;

            user_data = JSON.parse(Storage.get('user_data'));
            user_unit_id = user_data.unitid;
            let tariff_id;
            if (parseInt(basic_info['payment_type']) === 1) {
                tariff_id = 1;
            }
            // postService(getCashNonPackageRoomsByUnitId, 'POST', { "data": { "unit_id": user_unit_id, "payment_type": basic_info['payment_type'], "tariff_id": tariff_id, "room_type": 1 } }).then(res => {
                postService(getInsuranceNonPackageRoomsByUnitId, 'POST', { "data": { "unit_id": user_unit_id, "payment_type": 1, "tariff_id": "TR1", "room_type": 1 } }).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`} room_id={`${data.room_id}`}  amount={`${data.amount}`} wardgroupname={`${data.wardgroupname}`} >{`${data.room_name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
        }

        if (feild_data.name === 'room_upgrade_reason') {
            postService(getRoomUpgradeReasons, 'POST', { "data": { "payment_type": basic_info['payment_type'] } }).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
        }

        if (feild_data.name === 'care_management') {
            postService(getMasterCareManagement, 'GET', {}).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`} name={`${data.name}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
        }

        if (feild_data.name === 'estimate_type') {

            postService(getMasterEstimateTypes, 'GET', {}).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
        }

        if (feild_data.name === 'package_name') {
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            let payment_type = basic_info['payment_type'];
            let payment_mode;
            if (payment_type === 1) {
                payment_mode = 'Cash';
            }
            if (payment_type === 2) {
                payment_mode = 'Insurance';
            }

            postService(getPackagesForDropDown, 'POST', { "data": { "payment_type": 1, 'unit_id': user_unit_id, 'tariff_mapped': 1 } }).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`} length_of_stay={`${data.length_of_stay}`}>{`${data.package_name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });
        }

        if (feild_data.name === 'additional_procedure') {
            console.log('feild_data', feild_data)
            try {
                let { basic_info } = this.props;
                let user_data = JSON.parse(Storage.get('user_data'));
                let user_unit_id = user_data.unitid;
                let payment_type = this.props.basic_info && this.props.basic_info['payment_type'];
                let tariff_id;
                if (this.props.basic_info !== undefined) {
                    if (parseInt(basic_info['payment_type']) === 1) {
                        tariff_id = 1;
                    }
                }

                let { counselling_details } = this.props;
                if (counselling_details) {
                    payment_type = counselling_details['payment_type_id'];
                    if (payment_type === 1) {
                        tariff_id = 1;
                    }
                }


                postService(getServicesByHeaderId, 'POST', { data: { payment_type: payment_type, unit_id: user_unit_id, header_id: feild_data.header, sub_header_id: feild_data.sub_header, tariff_mapped: tariff_id } }).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} option_data={data} value={`${data.id}`}>{`${data.name}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children, loading: false }), () => {
                            // this.inputBlur();
                        });
                    } else {
                        this.setState((state) => ({ 'selet_options': [], loading: false }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                });

                this.setState((state) => ({ 'selet_options': children, loading: false }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [], loading: false }));
                console.log(error);
            }
        }
        if (feild_data.name === 'surgery_procedure_name' || feild_data.name ==='ins_surgery_procedure_name'){
        // postService(getProcedures, 'GET', 'null').then(res => {
        //     if (res) {
        //         res['data'].map((data, key) => {
        //             children.push(<Option key={key} option_data={data} value={`${data.id}`}>{`${data.name}`}</Option>)
        //         })
        //         this.setState((state) => ({ 'selet_options': children, fetching: false }));
        //         // this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
        //     } else {
        //         this.setState({ fetching: false });
        //     }
        // });
        let {tariff_mapped} = this.props;
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid; 
            let lengthofstay = null
            let payload = {
                // "tariff_id" : tariff_mapped,
                "search_key": val || '',
                "unit_id": user_unit_id
            }
        postService('getProcedures', 'POST', {data:payload}).then(async(res) => {
            if (res) {
                res['data'].map((data, key) => {
                    // children.push(<Option key={key} option_data={data} value={`${data.service_code}`}>{`${data.name}`}</Option>)
                    children.push(<Option key={key} option_data={data} value={`${data.id}`}>{`${data.name}`}</Option>)     
                })
                this.setState((state) => ({ 'selet_options': children, fetching: false }));
                // this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
            } else {
                this.setState({ fetching: false });
            }
        });
    }

        if (feild_data.name === 'tpa_name') {
            let user_data = JSON.parse(localStorage.getItem('user_data'))
            let paload={
                unit_id:user_data['unitid']&&user_data['unitid']
            }
            postService(getAllTpas, 'POST', {'data':paload}).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.tpa_name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '1' //`${res.message}`,
                    // });
                }
            });
        }

        if (feild_data.name === 'insurance_company_name') {           

            console.log('insurance_company_name',this.state.value);
            let user_data = JSON.parse(localStorage.getItem('user_data'));
            console.log("this.props.tpa_name",this.props,this.props.tpa_name);
            let {tpa_name, counselling_details} = this.props
            postService(getAllInsuranceCompanies, 'POST', {
                "data": { "tpa_name": tpa_name ? tpa_name : counselling_details.tpa_name,"unit_id":user_data['unitid']&&user_data['unitid'] }
            }).then(res => {
                console.log('insurance_company_name',this.state.value,res,this.props.tpa);
                rootReduxStore.dispatch({ type: 'GET_ALL_INSURANCE_COMPANIES', data: res.data })
                if (res['status']) {
                    console.log('insurance_company_name',this.state.value);

                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`} tariff_mapped={`${data.tariff_mapped}`} hims_org_code={`${data.tpacd}`} insurance_company_mou_flag={`${data.insurance_company_mou_flag}`}>{`${data.insurance_company_name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        if (this.state.value) {
                            console.log('insurance_company_name',this.state.value);

                            this.inputBlur();
                        }
                    
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '2' //`${res.message}`,
                    // });
                }
            });
        }

        if (feild_data.name === 'insurance_status') {

            postService(getMasterInsuranceStatus, 'GET', 'null').then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '3' //`${res.message}`,
                    // });
                }
            });
        }

        if (feild_data.name === 'type_of_patient') {
            postService(getMasterPatientTypes, 'GET', 'null').then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '4' //`${res.message}`,
                    // });
                }
            });


        }

        if (feild_data.name === 'type_insurance') {

            postService(getMasterInsuranceTypes, 'GET', 'null').then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '5' //`${res.message}`,
                    // });
                }
            });


        }

        if (feild_data.name === 'ins_package_name') {
            let user_data = JSON.parse(Storage.get('user_data'));
            let user_unit_id = user_data.unitid;
            let payment_mode = basic_info['payment_type'];
            // let tariff = this.props.tariff_mapped ? parseInt(this.props.tariff_mapped) : null
            let tariff = this.props.tariff_mapped ? this.props.tariff_mapped : null

            postService(getPackagesForDropDown, 'POST', { "data": { "payment_type": payment_mode, 'unit_id': user_unit_id, "tariff_mapped": tariff } }).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`} length_of_stay={`${data.length_of_stay}`} text={`${data.package_name}`}>{`${data.package_name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '6' //`${res.message}`,
                    // });
                }
            });
        }
        if (feild_data.name === 'ins_additional_package_name') {
            console.log('feild_data', feild_data)
            try {
                let { basic_info } = this.props;
                let user_datas = JSON.parse(localStorage.getItem('user_data'))
                let user_unit_id = user_datas.unitid;

                postService(getServicesByHeaderId, 'POST', { data: { payment_type: 2, unit_id: user_unit_id, header_id: feild_data.header, sub_header_id: feild_data.sub_header, tariff_mapped: this.props.tariff_mapped ? parseInt(this.props.tariff_mapped) : null } }).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} option_data={data} value={`${data.id}`}>{`${data.name}`}</Option>)

                            // children.push(<Option key={key} value={`${data.id}`}>{`${data.name}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children, loading: false }), () => {
                            // this.inputBlur();
                        });
                    } else {
                        this.setState((state) => ({ 'selet_options': [], loading: false }));
                        // Modal.error({
                        //     title: 'Error message',
                        //     content: '7' //`${res.message}`,
                        // });
                    }
                });

                this.setState((state) => ({ 'selet_options': children, loading: false }));
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [], loading: false }));
                console.log(error);
            }
        }

        if (feild_data.name === 'ins_room_eligible_ward_names' || feild_data.name === 'ins_upgrade_room_names') {
            let package_data = null;
            let type_of_package = null
            let payment_type = null;
            let insurance_company = null;
            let tpa = null;
            let user_data = null;
            let room_eligible_ward_cost = 0;
            let {insurance_company_mou_flag, estimateTypeValue,hims_org_code,InsuranceDetailsSchema,WardAmount} = this.props;
            console.log('this.props',this.props)
            // let {room_eligible_ward_amount} = counselling_details;
            room_eligible_ward_cost = localStorage.getItem('room_eligible_ward_cost');
            let Wardamount = WardAmount;
            if (localStorage.getItem('package_name') !== null) {
                package_data = localStorage.getItem('package_name')
            }
            type_of_package = localStorage.getItem('estimateTypeValue');

            payment_type = localStorage.getItem('payment');
            // if (localStorage.getItem('insurance_company') !== null || localStorage.getItem('tpa_name') !== null) {
            //     insurance_company = localStorage.getItem('insurance_company')
            //     tpa = localStorage.getItem('tpa_name');
            // }

            if (localStorage.getItem('user_data') !== null) {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            let payload = {}
            let url = null;
            if (InsuranceDetailsSchema[13].value === 1 || InsuranceDetailsSchema[13].value === '1' || estimateTypeValue === 1) {
                url = getInsurancePackagePricesById;
                payload = {
                    "unit_id": user_data['unitid'],
                    // "package_id": this.props.package_id ? parseInt(this.props.package_id) : null,
                    "package_id": this.props.ProcedureCode ? this.props.ProcedureCode : InsuranceDetailsSchema[12].value,
                    "tariff_id": this.props.tariff_mapped,
                    "tpa_name": this.props.tpa_name,
                    "room_type": 0,
                    "payment_type": 2,
                    "tpacd": this.props.hims_org_code,
                    "tpaid": InsuranceDetailsSchema[8].value,
                }
            } else {
                url = getInsuranceNonPackageRoomsByUnitId;
                payload = {
                    // "tariff_id": this.props.tariff_mapped ? parseInt(this.props.tariff_mapped) : null,
                    "tariff_id": this.props.tariff_mapped,
                    "unit_id": user_data['unitid'],
                    "payment_type": 2,
                    "tpa_name": this.props.tpa_name,
                    "room_type": 0,
                    'package':1,
                    "tpacd": this.props.hims_org_code,
                    "tpaid": InsuranceDetailsSchema[8].value,
                }
            }

            // if (feild_data.name === 'ins_icu_type') {
            //     url = getInsuranceNonPackageRoomsByUnitId;
            //     payload = {
            //         // "tariff_id": this.props.tariff_mapped ? parseInt(this.props.tariff_mapped) : null,
            //         "tariff_id": this.props.tariff_mapped,
            //         "unit_id": user_data['unitid'],
            //         "payment_type": 2,
            //         "room_type": 1
            //     }
            //     room_eligible_ward_cost = null;
            // }




            postService(url, 'POST', {
                "data": payload
            }).then(res => {

                if (res) {
                    let newData = [];
                    // const validRoomTypes = ["DELUXE", "DELUXE -C-19", "SUITE", "PREMIUM SUITE", "PRESIDENTIAL SUITE ROOM", "PSR" ];
                    // const insuranceCompanyNames = ['STAR HEALTH INSURANCE CORPORATE LIMITED', 'HDFC ERGO GENERAL INSURANCE'];
                    // const units = ['UN0','UN1','UN2','UN10','UN11'];
                    if (res.data.length !== 0) {
                        if (InsuranceDetailsSchema[4].value === 1 || estimateTypeValue === 1) {
                            if(units.includes(user_data['unitid']) && insuranceCompanyCodes.includes(hims_org_code)){
                                if (feild_data.name === 'ins_room_eligible_ward_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        const isValidRoom = !validRoomTypes.includes(data.ward_groupname);
                                        const isEligibleCost = parseFloat(data.amount || data.room_charges) < parseFloat(room_eligible_ward_cost);
                                        return isValidRoom && isEligibleCost;
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} select_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={`${data.amount}`} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_charges={`${data.package_charges}`} package_id={`${data.package_id}`} ward_groupname={`${data.ward_groupname}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                                if (feild_data.name === 'ins_upgrade_room_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        const isValidRoom = !validRoomTypes.includes(data.ward_groupname);
                                        const isEligibleCost = parseFloat(data.amount || data.room_charges) > parseFloat(Wardamount);
                                        return isValidRoom && isEligibleCost;
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} select_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={data.room_charges || data.amount} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_charges={`${data.package_charges}`} package_id={`${data.package_id}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                            } else {
                                if (feild_data.name === 'ins_room_eligible_ward_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        console.log("room_eligible_ward_cost",room_eligible_ward_cost);
                                        return parseFloat(data.amount || data.room_charges) < parseFloat(room_eligible_ward_cost);
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} select_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={`${data.amount}`} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_charges={`${data.package_charges}`} package_id={`${data.package_id}`} ward_groupname={`${data.ward_groupname}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                                if (feild_data.name === 'ins_upgrade_room_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        return parseFloat(data.amount || data.room_charges) > parseFloat(Wardamount);
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} select_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={data.room_charges || data.amount} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_charges={`${data.package_charges}`} package_id={`${data.package_id}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                            }
                        } else {
                            if(units.includes(user_data['unitid']) && insuranceCompanyCodes.includes(hims_org_code)){
                                if (feild_data.name === 'ins_room_eligible_ward_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        const isValidRoom = !validRoomTypes.includes(data.ward_groupname);
                                        const isEligibleCost = parseFloat(data.amount || data.room_charges) < parseFloat(room_eligible_ward_cost);
                                        return isValidRoom && isEligibleCost;
                                    });
                                    dataroom.map((data, key) => {
                                        console.log("dataroom",dataroom);
                                        // children.push(<Option key={key} option_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={`${data.amount}`} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_id={`${data.package_id}`} ward_groupname={`${data.ward_groupname}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                                if (feild_data.name === 'ins_upgrade_room_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        const isValidRoom = !validRoomTypes.includes(data.ward_groupname);
                                        const isEligibleCost = parseFloat(data.amount || data.room_charges) > parseFloat(Wardamount);
                                        return isValidRoom && isEligibleCost;
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} option_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={data.room_charges || data.amount} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_id={`${data.package_id}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                            } else {
                                if (feild_data.name === 'ins_room_eligible_ward_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        return parseFloat(data.amount) < parseFloat(room_eligible_ward_cost);
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} option_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={`${data.amount}`} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_id={`${data.package_id}`} ward_groupname={`${data.ward_groupname}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                                if (feild_data.name === 'ins_upgrade_room_names') {
                                    let dataroom = res['data'];
                                    dataroom.sort(function (a, b) {
                                        return a.amount - b.amount;
                                    });
                                    dataroom = dataroom.filter(data => {
                                        return parseFloat(data.amount || data.room_charges) > parseFloat(Wardamount);
                                    });
                                    dataroom.map((data, key) => {
                                        // children.push(<Option key={key} option_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={data.room_charges || data.amount} package_id={`${data.tariff_name}`} >{`${data.room_name}`}</Option>)
                                        children.push(<Option key={key} option_data={data} value={`${data.room_id}`} amount={data.room_charges || data.amount} package_id={`${data.package_id}`} >{`${data.room_name}`}</Option>)
                                    });
                                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                                }
                            }
                            
                        }
                    }
                    this.setState((state) => ({ selet_options: children, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }

        if (feild_data.name === 'ins_icu_type') {
            let user_data = null;
            if (localStorage.getItem('user_data') !== null) {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            let payload = {
                // "tariff_id": this.props.tariff_mapped ? parseInt(this.props.tariff_mapped) : null,
                "tariff_id": this.props.tariff_mapped,
                "unit_id": user_data['unitid'],
                "payment_type": 2,
                "tpa_name": this.props.tpa_name,
                "room_type": 1,
                "tpacd": this.props.hims_org_code,
                "tpaid": InsuranceDetailsSchema[8].value,
            }
            let {ins_room_eligible_ward} =  this.props;
            postService(getInsuranceNonPackageRoomsByUnitId, 'POST', {'data':payload}).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} select_data={data} value={`${data.room_id}`} name={`${data.room_name}`} amount={`${data.amount}`} package_id={`${data.tariff_name}`} ward_groupname={`${data.ward_groupname}`} >{`${data.room_name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }), () => {
                        // this.inputBlur();
                    });
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    Modal.error({
                        title: 'Error message',
                        content: `${res.message}`,
                    });
                }
            });


        }
        if (feild_data.name === 'ins_room_upgrade_reason') {
            postService(getRoomUpgradeReasons, 'POST', { "data": { "payment_type": basic_info['payment_type'] } }).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.value}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '8' //`${res.message}`,
                    // });
                }
            });
        }
        if (feild_data.name === 'category') {
            postService(getCallLogCategories, 'POST', { "data": { "unit_id": 'UN1',"activity_type": "admission" } }).then(res => {
                if (res['status']) {
                    res['data'].map((data, key) => {
                        children.push(<Option key={key} value={`${data.id}`}>{`${data.name}`}</Option>)
                    })
                    this.setState((state) => ({ 'selet_options': children, fetching: false }));
                } else {
                    this.setState((state) => ({ 'selet_options': [], fetching: false }));
                    // Modal.error({
                    //     title: 'Error message',
                    //     content: '8' //`${res.message}`,
                    // });
                }
            });
        }

    }

    fetchSearchData(value) {
        // return
        let { feild_data } = this.props;
        // let { base_url } = this.props.networkList
        let { base_url } = networkList
        const Option = Select.Option;
        let children = [];
        if (feild_data.name === 'subreports') {
            var data = {
                "search_key": value
            }
            try {
                postService(`${base_url}getReports`, 'POST', data).then(res => {
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} value={`${data._id}`}>{`${data.report_title}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children, fetching: false }));
                    } else {
                        this.setState((state) => ({ 'selet_options': [], fetching: false }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [], fetching: false }));
                console.log(error);
            }
        }

        if (feild_data.name === 'searchableReports') {
            var data = {
                "search_key": value
            }
            try {
                postService(`${base_url}getChartReports`, 'POST', data).then(res => {
                    console.log(res)
                    if (res['status']) {
                        res['data'].map((data, key) => {
                            children.push(<Option key={key} value={`${data._id}`}>{`${data.report_title}`}</Option>)
                        })
                        this.setState((state) => ({ 'selet_options': children, fetching: false }));
                    } else {
                        this.setState((state) => ({ 'selet_options': [], fetching: false }));
                        Modal.error({
                            title: 'Error message',
                            content: `${res.message}`,
                        });
                    }
                })
            } catch (error) {
                this.setState((state) => ({ 'selet_options': [], fetching: false }));
                console.log(error);
            }
        }
        if (feild_data.name === 'surgery_procedure_name' || feild_data.name ==='ins_surgery_procedure_name'){
            this.selectFetchCall(value);
        }
    }


    render() {
        let { feild_data } = this.props;
        let { selet_options, value, fetching,text } = this.state;
        return (
            <React.Fragment>
                {/* <div className={`${feild_data.class['cols'] ? feild_data.class['cols'] : 'col-12'} form-group`}> */}
                <div className={`${feild_data.className ? feild_data.className + ' align-self-end' : "col-4 mt-3"}`}>
                    {feild_data.title ? <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label> : null}
                    {feild_data.disable && <p className="form-control mb-0 disable">{feild_data.value ? feild_data.text || feild_data.value : '--'}</p>}
                    {feild_data.disable === false && <Select
                        value={value ?feild_data.name==='care_management'?value.toString(): feild_data.text : (feild_data.type === 'single' ? null : [])}
                        disabled={feild_data.disabled ? feild_data.disabled : false}
                        showSearch
                        mode={feild_data.type}
                        style={{ width: '100%' }}
                        placeholder={feild_data.placeholder}
                        optionFilterProp="children"
                        onSearch={this.fetchSearchData}
                        onChange={this.inputChange}
                        onFocus={this.onFocus.bind(this)}
                        showArrow={true}
                        allowClear={true}
                        id={feild_data.name}
                        // onDeselect={this.inputBlur}
                        // onBlur={this.inputBlur}
                        loading={false}
                        dropdownMatchSelectWidth={false}
                        notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    >
                        
                        {selet_options}
                    </Select>}
                    {/* {(feild_data.error) && <small id={feild_data.name} class="form-text text-danger">{feild_data.error}</small>} */}
                    {feild_data.errors.map((error, eKey) => {
                        return (<small key={eKey} className="form-text text-danger" id={'errorm'+feild_data.name}>{error.message}</small>);
                    })}
                </div>
            </React.Fragment>
        );
    }
}

export default Selectlayer;
